module.exports = __webpack_public_path__ + "img/logo.fa0e8530.png";